import request from "@/utils/request";
import { Toast } from "vant";
import { permissionTypeState } from "../../pages/cps/utils/const.js";

const cps = {
  state: {
    cpsSignInfo: {},
    cpsShowContract: false,
    cpsHasPermission: permissionTypeState.unReq
  },
  mutations: {
    SET_CPS_SIGN_INFO: (state, cpsSignInfo) => {
      state.cpsSignInfo = cpsSignInfo;
    },
    SET_CPS_SHOW_CONTRACT: (state, value) => {
      state.cpsShowContract = value;
    },
    SET_CPS_PERMISSION: (state, value) => {
      state.cpsHasPermission = value;
    }
  },
  actions: {
    getCpsSignInfo({ commit }) {
      return request.get("/cps/getSignStatus").then(res => {
        if (res.errorCode === 0) {
          commit("SET_CPS_SIGN_INFO", res.data);
        } else {
          res.msg && Toast(res.msg);
        }
      });
    },

    getCpsPermission({ commit }) {
      return request.get("/mall/cps/entry/permission").then(res => {
        if (res.errorCode === 0) {
          commit("SET_CPS_PERMISSION", permissionTypeState.hasPermission);
        } else if (res.errorCode == "940001") {
          commit("SET_CPS_PERMISSION", permissionTypeState.noPermission);
        } else {
          res.msg && Toast(res.msg);
        }
      });
    }
  }
};

export default cps;
